import { Recipe } from 'common/hooks/useProducer';
import exhaustivnessCheck from 'common/utils/exhaustivnessCheck';
import { AccountTransfersState } from './states';
import {
  AcceptAccountTransferActions,
  AccountTransfersActions,
  DeclineAccountTransferActions,
  NewAccountTransferActions,
} from './actions';
import { APIRequestState } from 'api';

// #region AccountTransfer
export const accountTransfersRecipe: Recipe<
  AccountTransfersState,
  AccountTransfersActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/transfers/started':
      draft.pending = true;
      return;

    case 'accounts/transfers/finished':
      draft.pending = false;
      draft.transfers = action.transfers;
      draft.count = action.count || 0;
      draft.next = action.next;
      draft.previous = action.previous;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const newAccountTransferRecipe: Recipe<
  APIRequestState,
  NewAccountTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/transfers/new/started':
      draft.pending = true;
      return;

    case 'accounts/transfers/new/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const acceptAccountTransferRecipe: Recipe<
  APIRequestState,
  AcceptAccountTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/transfers/accept/started':
      draft.pending = true;
      return;

    case 'accounts/transfers/accept/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};

export const declineAccountTransferRecipe: Recipe<
  APIRequestState,
  DeclineAccountTransferActions
> = (draft, action) => {
  switch (action.type) {
    case 'accounts/transfers/decline/started':
      draft.pending = true;
      return;

    case 'accounts/transfers/decline/finished':
      draft.pending = false;
      draft.success = action.success;
      draft.error = action.error;
      return;

    default:
      exhaustivnessCheck(action);
  }
};
// #endregion
